import axios from "axios";//创建一个axios的对象
//生成一个axios的实例
const http=axios.create({
	baseURL:"http://1.94.56.12:8081/",// baseURL会在发送请求的时候拼接在url参数前面
    // baseURL:"http://192.168.30.188:8081/",// baseURL会在发送请求的时候拼接在url参数前面
	timeout:50000,//请求超时
});

// Request interceptors for API calls
http.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
        return config;
    // },
    // config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImRlMmIyNzRkLWFkMmMtNGI3Mi1iMDlkLTk3NWU2MDU0MGNhMCJ9.uagYLPQQ5sCjrVqEgwViXHKJsXqPnU-0zM7BGMTK520_2SZl9q5bvLkw_vcTwsJRIM0lQsPnDgYbIrQdQZRs6Q`;
    // return config;
},
    
    error => {
        return Promise.reject(error);
    }
);
export default http;// 导出






